import styled from "styled-components";

const FooterStyled = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 48px;
  box-sizing: border-box;

  background-color: var(--color-white);
  border-top: 1px solid var(--color-black-1);
`;

const ClearLogo = styled.img`
  max-height: 20px;
  object-fit: contain;
`;

export function Footer(): JSX.Element {
  return (
    <FooterStyled className="w-full p-3">
      <ClearLogo src="/logo_new.svg" alt="Clear Health Logo" />
    </FooterStyled>
  );
}
